<template>
  <LoadMoreControl
    color="primary"
    :is-loading="plansStore.isAppending"
    variant="solid"
    @load-more="handleLoadMore"
  />
</template>

<script setup lang="ts">
import { PLANS_QUERY_DEFAULTS } from '@constants/plansQuery';

import { usePlansStore } from '@/stores/plans';
import { usePlansQueryStore } from '@/stores/plansQuery';

const plansStore = usePlansStore();
const plansQueryStore = usePlansQueryStore();

const handleLoadMore = () => {
  plansStore.loadMore(plansQueryStore.filter, {
    ...plansQueryStore.apiQueryParams,
    limit: PLANS_QUERY_DEFAULTS.LIMIT,
  });
};
</script>
